import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

import makeFirstRequest from '../../assets/img/make-first-request.png';

const Icon: React.FC<IconProps> = ({ className }) => (
    <img className={className} width='150' height='178' src={makeFirstRequest} alt='Start Search' />
);

export const StartSearchIcon = styled(Icon)({});
